<template>
    <div class="tuike">
        <header1></header1>
        <div class="main-tuike">
            <div class="nav-bg">
                <div class="nav-banner">
                    <div class="banner-box">
                        <div class="left">
                            <div class="title">契合科技H5快易搭</div>
                            <div class="title">高效赋能强互动性H5营销</div>
                            <p class="sub-title">
                                契合科技H5快易搭平台，支持海量精美金融场景模板素材，通过可视
                                化操作台，自由拖拽丰富组件，高效、直观生成H5营销解决方案。
                            </p>
                            <div>
                                <a @click="denglu" class="btn">立即试用</a>
                            </div>
                        </div>
                        <div class="nav-bars">
                            <div class="bar">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/h5crm/icon_1_1.png"
                                    alt=""
                                />
                                <div>
                                    <div class="txt">海量模板</div>
                                    <div class="subtxt">
                                        拥有海量强金融场景模板、素材。
                                    </div>
                                </div>
                            </div>
                            <div class="bar">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/h5crm/icon_1_2.png"
                                    alt=""
                                />
                                <div>
                                    <div class="txt">丰富组件</div>
                                    <div class="subtxt">
                                        拖拉拽丰富多样组件，形成强交互营销。
                                    </div>
                                </div>
                            </div>
                            <div class="bar">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/h5crm/icon_1_3.png"
                                    alt=""
                                />
                                <div>
                                    <div class="txt">扫码浏览</div>
                                    <div class="subtxt">
                                        H5作品支持扫码浏览，所见即所得。
                                    </div>
                                </div>
                            </div>
                            <div class="bar">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/h5crm/icon_1_4.png"
                                    alt=""
                                />
                                <div>
                                    <div class="txt">营销追踪</div>
                                    <div class="subtxt">
                                        录入表单、行为数据，线索一网打尽。
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap mt163">
                <div class="dom-item">
                    <div class="dom-title">H5营销丰富使用场景</div>
                    <div class="dom-content flex mt60">
                        <div class="p-item">
                            <div class="p-item-title">活动前期宣传</div>
                            <div class="p-item-ontitle">活动前期宣传</div>
                            <div class="p-item-desc">
                                重大节假日，企业开展主会场、嘉年华等大型营销活动，开始前一周通过定向推送，用户收到了一张参与活动的H5邀请函。
                            </div>
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/h5crm/icon_2_1.png"
                                alt=""
                                class="icon_img"
                            />
                        </div>
                        <div class="p-item">
                            <div class="p-item-title">收集报名信息</div>
                            <div class="p-item-ontitle">收集报名信息</div>
                            <div class="p-item-desc">
                                线下业务常常通过报名表单的形式初步收集用户意向，勾选用户协议以合规化数据收集，手机号验证以确认信息有效性。
                            </div>
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/h5crm/icon_2_2.png"
                                alt=""
                                class="icon_img"
                            />
                        </div>
                        <div class="p-item">
                            <div class="p-item-title">倒计时浏览H5页面</div>
                            <div class="p-item-ontitle">倒计时浏览H5页面</div>
                            <div class="p-item-desc">
                                用户参与营销活动任务「浏览理财产品获抽奖机会」，跳转浏览理财产品落地页后，浏览组件触发倒计时动效，用户返回活动任务已达标。
                            </div>
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/h5crm/icon_2_3.png"
                                alt=""
                                class="icon_img"
                            />
                        </div>
                        <div class="p-item">
                            <div class="p-item-title">获取用户反馈</div>
                            <div class="p-item-ontitle">获取用户反馈</div>
                            <div class="p-item-desc">
                                企业开展的营销活动、售卖的产品一定时间间隔可收集一次用户反馈，为下一次企业服务提供有力抓手。
                            </div>
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/h5crm/icon_2_4.png"
                                alt=""
                                class="icon_img"
                            />
                        </div>
                        <div class="p-item">
                            <div class="p-item-title">入企微群福利引导</div>
                            <div class="p-item-ontitle">入企微群福利引导</div>
                            <div class="p-item-desc">
                                通过入群领红包内容结合H5营销手段，引导用户沉淀入企业微信群。
                            </div>
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/h5crm/icon_2_5.png"
                                alt=""
                                class="icon_img"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap dom-type-1">
                <div class="dom-item">
                    <div class="dom-title">我们的解决方案</div>
                    <div class="boxes">
                        <div class="box">
                            <div class="num-info">
                                <span class="num">01</span
                                ><span class="arr"></span>
                            </div>
                            <div class="txt">海量模板</div>
                            <div class="txt">丰富的金融场景</div>
                        </div>
                        <div class="box">
                            <div class="num-info">
                                <span class="num">02</span
                                ><span class="arr"></span>
                            </div>
                            <div class="txt">丰富组件</div>
                            <div class="txt">与用户形成强互动</div>
                        </div>
                        <div class="box">
                            <div class="num-info">
                                <span class="num">03</span
                                ><span class="arr"></span>
                            </div>
                            <div class="txt">拖拉拽编辑</div>
                            <div class="txt">简单速成H5页面</div>
                        </div>
                        <div class="box">
                            <div class="num-info">
                                <span class="num">04</span
                                ><span class="arr"></span>
                            </div>
                            <div class="txt">营销数据追踪</div>
                            <div class="txt">营销线索一网打尽</div>
                        </div>
                        <div class="box">
                            <div class="num-info">
                                <span class="num">05</span
                                ><span class="arr"></span>
                            </div>
                            <div class="txt">所见即所得</div>
                            <div class="txt">扫码浏览页面</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap dom-type-2">
                <div class="dom-item">
                    <div class="img-txt">
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/h5crm/part_1.png"
                            alt=""
                        />
                        <div class="desc">
                            <div class="intro">
                                模版分类按照金融场景、节日、风格进行区分，针对银行的业务场景，如基金理财、活动报告、信用卡、贷款、银行App下载等设置了相应的H5模版，为您带来更精准的服务。
                            </div>
                            <div class="intro-title">海量模版</div>
                            <div class="intro-content">
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >全面覆盖金融场景</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >100+模板随选随用</span
                                        >
                                    </div>
                                </div>
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >丰富节日营销素材</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >多元风格赋能场景</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="img-txt flex-reverse">
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/h5crm/part_2.png"
                            alt=""
                        />
                        <div class="desc">
                            <div class="intro">
                                多元的金融场景强相关组件库，手机号验证、视频、轮播图、用户协议、单/复选框、提交按钮等都有相应的组件素材，真正实现与用户强交互的操作体验。
                            </div>
                            <div class="intro-title">丰富组件</div>
                            <div class="intro-content">
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >表单类组件收集有效信息</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >任务类组件赋能营销场景</span
                                        >
                                    </div>
                                </div>
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >个性化组件体验优质服务</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >强交互式玩转营销全链路</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="img-txt">
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/h5crm/part_3.png"
                            alt=""
                        />
                        <div class="desc">
                            <div class="intro">
                                强大的编辑区，使用简单的拖拉拽方式即可快速搭建H5，能够实现精细化调整文字、图片，同时可视化的操作体验让用户在编辑使用的时候，更便捷、更灵活。
                            </div>
                            <div class="intro-title">拖拉拽编辑</div>
                            <div class="intro-content">
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt">操作便捷</span>
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt">敏捷高效</span>
                                    </div>
                                </div>
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt">直观展示</span>
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt">灵活编辑</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="img-txt flex-reverse">
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/h5crm/part_4.png"
                            alt=""
                        />
                        <div class="desc">
                            <div class="intro">
                                创建的H5都独立拥有数据看板，不仅可查看活动的pv、uv，而且支持在页面上录入用户表单信息、行为数据，真正实现将营销线索一网打尽。
                            </div>
                            <div class="intro-title">营销数据追踪</div>
                            <div class="intro-content">
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt">PV、UV</span>
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt">表单数据</span>
                                    </div>
                                </div>
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt">行为数据</span>
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >营销线索一网打尽</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="img-txt">
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/h5crm/part_5.png"
                            alt=""
                        />
                        <div class="desc">
                            <div class="intro">
                                创建的H5都独立拥有数据看板，不仅可查看活动的pv、uv，而且支持在页面上录入用户表单信息、行为数据，真正实现将营销线索一网打尽。
                            </div>
                            <div class="intro-title">所见即所得</div>
                            <div class="intro-content">
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >发布生成H5链接</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >手机扫描二维码</span
                                        >
                                    </div>
                                </div>
                                <div class="intro-item-box">
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >深入场景直观浏览</span
                                        >
                                    </div>
                                    <div class="intro-item">
                                        <span class="gou"></span
                                        ><span class="intro-txt"
                                            >H5页面高度保真</span
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap">
                <div class="dom-item">
                    <div class="dom-title">优秀案例</div>
                    <div class="tab">
                        <div class="tab-h">
                            <div
                                :class="item.active_no ? 'on' : ''"
                                v-for="(item, index) in tabs"
                                :key="index"
                                @click="activeTabs(index)"
                            >
                                {{ item.name }}
                            </div>
                        </div>
                        <div class="tab-b">
                            <div class="pre" @click="swipw_prev"></div>
                            <van-swipe
                                class="my-swipe"
                                indicator-color="white"
                                @change="onChange"
                                ref="mySwiper"
                            >
                                <van-swipe-item>
                                    <div class="tab-content tab-content1">
                                        <div class="tab-content-info">
                                            <div class="tab-content-info-title">
                                                建信金科生态合作-建行全链路营销
                                            </div>
                                            <div class="tab-content-info-desc">
                                                自2019年起，中国建设银行已使用H5快易搭平台搭建百余个H5页面，与营销活动平台联合，快速满足丰富场景。
                                            </div>
                                        </div>
                                    </div>
                                </van-swipe-item>
                                <van-swipe-item>
                                    <div class="tab-content tab-content2">
                                        <div class="tab-content-info r">
                                            <div class="tab-content-info-title">
                                                中信银行合作
                                            </div>
                                            <div class="tab-content-info-desc">
                                                自2020年起，中信银行总行以及30+分行，高频使用H5快易搭平台搭建近千张H5页面，用于营销活动宣传、线上线下业务紧密结合的金融营销场景。
                                            </div>
                                        </div>
                                    </div>
                                </van-swipe-item>
                                <van-swipe-item>
                                    <div class="tab-content tab-content3">
                                        <div class="tab-content-info">
                                            <div class="tab-content-info-title">
                                                厦门银行合作
                                            </div>
                                            <div class="tab-content-info-desc">
                                                自2019年起，厦门银行在H5快易搭平台自主搭建的H5页面已高频使用在手机银行、公众号上，场景丰富，操作便捷。
                                            </div>
                                        </div>
                                    </div>
                                </van-swipe-item>
                                <van-swipe-item>
                                    <div class="tab-content tab-content4">
                                        <div class="tab-content-info r">
                                            <div class="tab-content-info-title">
                                                郑州银行合作
                                            </div>
                                            <div class="tab-content-info-desc">
                                                郑州银行使用快易搭平台目前已经搭建百余个H5页面，在线上运营开展的场景多元，页面精美。
                                            </div>
                                        </div>
                                    </div>
                                </van-swipe-item>
                            </van-swipe>
                            <div class="next" @click="swipw_next"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom">
            <more :moreid="id"></more>
            <info></info>
        </div>
    </div>
</template>

<script>
import header1 from "../../components/header1.vue";
import more from "../../components/more.vue";
import info from "../../components/info.vue";
export default {
    data() {
        return {
            tabs: [
                { name: "中国建设银行", active_no: true },
                { name: "中信银行", active_no: false },
                { name: "厦门银行", active_no: false },
                { name: "郑州银行", active_no: false },
            ],
            id: 2
        };
    },
    components: { header1, more, info },
    mounted() {
        var that = this;
        // this.common.mounted(that);
    },
    computed: {},
    methods: {
        nolond() {},
        onChange(index){
            var tab = this.tabs;
            tab.forEach((item, val) => {
                if (index == val) {
                    item.active_no = true;
                } else {
                    item.active_no = false;
                }
            });
        },
        swipw_prev() {
            this.$refs.mySwiper.prev();
        },
        swipw_next() {
            // swipeTo
            this.$refs.mySwiper.next();
        },
        activeTabs(index) {
            var tab = this.tabs;
            tab.forEach((item, val) => {
                if (index == val) {
                    item.active_no = true;
                } else {
                    item.active_no = false;
                }
            });

            this.$refs.mySwiper.swipeTo(index);
        },
         denglu() {
            this.$router.push({
                path: "/login",
            });
        },
    },
};
</script>
<style scoped>
@import "../../../static/chunk-h5crm.css";
</style>


// WEBPACK FOOTER //
// src/views/slg/h5crm.vue